import {
  OwnUpSmallBodyMedium,
  OwnUpSmallSubheadlineMedium
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { displayNumber } from '../../common/utils';
import { LoanTermToNumber, useMonthlyPayment } from '../data/dataProvider';

const HeaderWrapper = styled(OwnUpSmallSubheadlineMedium)`
  padding-top: 0 !important;
  margin-bottom: 8px !important;
`;

export const MonthlyPayment: React.FC = () => {
  const {
    state: { loanTerm },
    getMonthlyPayment
  } = useMonthlyPayment();
  return (
    <>
      <HeaderWrapper variant="h2">{displayNumber(getMonthlyPayment())}</HeaderWrapper>
      <OwnUpSmallBodyMedium variant="body1">
        Monthly payment for {LoanTermToNumber[loanTerm]} years
      </OwnUpSmallBodyMedium>
    </>
  );
};
